import { FacetFilter } from 'models/FacetFilter';
import warning from 'warning';
import { BasePageModel } from 'models/BasePageModel';
import { ValueFacetFilter } from 'models/ValueFacetFilter';
import { FilterDisplayType } from 'models/FilterDisplayType';
import { isProductlist } from 'views/ProductlistPage/selectors';
import { isSearchProductlistPage, ProductlistBase } from 'models/ProductlistPageModel';
import { PageState } from 'models/PageState';

export interface FilterPage {
  filterPanels: FacetFilter[];
  isCategoryFilterPage: boolean;
  categoryFilterFacet: string;
  categoryFilterName: string;
}
export const isFilterPage = (page: BasePageModel | FilterPage): page is FilterPage => {
  const r = (page as FilterPage).filterPanels !== undefined;
  warning(r, 'filter page require filterPanels');
  return r;
};

export const isValueFacetFilter = (facet?: FacetFilter): facet is ValueFacetFilter => {
  return !!facet && (facet as ValueFacetFilter).values !== undefined;
};

export const getNbrOfHits = (currentPage: BasePageModel) =>
  isProductlist(currentPage) ? currentPage.nbrOfHits : 0;

export const getTotalNbrOfHits = (currentPage: BasePageModel) =>
  isProductlist(currentPage) ? currentPage.totalNbrOfHits : 0;

export const getFilterPanels = (currentPage: BasePageModel) =>
  isProductlist(currentPage) ? currentPage.filterPanels : [];

interface CategoryFilterFacetProps extends ProductlistBase {
  categoryFilterFacet?: string;
}

const isCategoryFilterProductlist = (
  currentPage: BasePageModel
): currentPage is CategoryFilterFacetProps =>
  isProductlist(currentPage) || isSearchProductlistPage(currentPage);

export const getCategoryFilterFacet = (currentPage: BasePageModel) =>
  isCategoryFilterProductlist(currentPage) ? currentPage.categoryFilterFacet || '' : '';

export const getFilterPanelsWithoutFacet = (
  filterPanels: FacetFilter[],
  categoryFilterFacet: string
) => filterPanels?.filter(f => f.name !== categoryFilterFacet);

interface SliderValues {
  minValue: number;
  maxValue: number;
  selectedMin: number;
  selectedMax: number;
  rangeMin: number;
  rangeMax: number;
}

const getSliderValues = ({ maxValue, minValue, selectedMax, selectedMin }: SliderValues) => ({
  maxValue,
  minValue,
  selectedMax,
  selectedMin
});

export const getShouldDisablePrice = (filterPanel: Pick<FacetFilter, 'type'>) => {
  const isSlider = filterPanel.type === FilterDisplayType.SimpleSlider;
  if (!isSlider) {
    return false;
  }

  const values = filterPanel as unknown as SliderValues;
  return [...new Set(Object.values(getSliderValues(values)))].length <= 1;
};

export const filterPanelsSelector = (state: PageState) => getFilterPanels(state.currentPage);
export const webCatalogSelector = (state: PageState) => state.currentPage.webCatalog;
export const nbrOfHitsSelector = (state: PageState) => getNbrOfHits(state.currentPage);
export const totalNbrOfHitsSelector = (state: PageState) => getTotalNbrOfHits(state.currentPage);
export const categoryFilterFacetSelector = (state: PageState) =>
  getCategoryFilterFacet(state.currentPage);
